"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiInspiration = function IconUiInspiration(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M9.723 26a5.874 5.874 0 0 0 2.6 4.891l-2.45 4.019h21.358l-9.142-14.738L20.56 22.7A5.919 5.919 0 0 0 9.723 26zm12.387-2l5.527 8.91h-14.2l2.936-4.821 1.648 2.672zm-6.461-1.927a3.922 3.922 0 0 1 3.469 2.084l.262.491L18 26.924l-1.64-2.662-3 4.921a3.921 3.921 0 0 1 2.287-7.11z"
  }), _react.default.createElement("path", {
    d: "M37.956 33H46V7H10v8H2v26h35.937zM12 9h32v22h-6.039L38 15H12zm23.942 30H4V17h31.995z"
  }));
};

IconUiInspiration.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiInspiration;
exports.default = _default;